import {translations} from "../translations";
import renderCellExpand from "../GridCellExpand/renderCellExpand";
import {Box, Stack, Tooltip} from "@mui/material";
import {nullHandlingSortComparator} from "./nullHandlingSortComparator";

function createHeaderMultiline(key) {
    return (
        <Tooltip
            sx={{
                textOverflow: "clip",
                whiteSpace: "break-spaces",
                lineHeight: 1,
            }}
            title={translations[key].pl + ' (' + translations[key].en + ')'}>
            <Stack flexDirection={'column'} justifyContent={'center'} gap={'1.2rem'}>
                <Box
                    sx={{
                        height: '20px',
                        fontSize: '.71rem',
                        fontWeight: 'bold',
                    }}
                >{translations[key].pl}</Box>
                <Box
                    sx={{
                        fontSize: '.5rem'
                    }}
                >{translations[key].en}</Box>
            </Stack>
        </Tooltip>
    )
}

export const dataGridColumns = [
    {
        field: "nr_pkbwl",
        minWidth: 120,
        headerName: translations['nr_pkbwl'].pl + ' (' + translations['nr_pkbwl'].en + ')',
        renderHeader: _ => createHeaderMultiline('nr_pkbwl'),
        flex: 1,
        // type: "string",
        align: 'left',
        headerAlign: 'left',
        filterableByData: true,
        renderCell: (params) => {
            return (
                <a style={{textDecoration: 'none', fontWeight: 'bold', fontSize: '.8rem', color: "#00367f"}}
                   href={params.row.permalink}>{params.row.nr_pkbwl}
                </a>
            )
        },
    },
    {
        field: "klasyfikacja_zdarzenia",
        headerName: translations['klasyfikacja_zdarzenia'].pl + ' (' + translations['klasyfikacja_zdarzenia'].en + ')',
        renderHeader: _ => createHeaderMultiline('klasyfikacja_zdarzenia'),
        flex: 1,
        filterableByData: true,
        renderCell: (params) => {
            return renderCellExpandOrPlaceholder(params)
        },
        valueGetter(params) {
            return getValueOrNull(params)
        },
        sortComparator: nullHandlingSortComparator,
    },
    {
        field: "data_zdarzenia",
        headerName: translations['data_zdarzenia'].pl + ' (' + translations['data_zdarzenia'].en + ')',
        renderHeader: _ => createHeaderMultiline('data_zdarzenia'),
        type: "date",
        flex: 1,
        filterableByData: true,
        renderCell: (params) => {
            return renderValueOrPlaceholder(params)
        },
        valueGetter(params) {
            return getValueOrNull(params)
        },
        sortComparator: nullHandlingSortComparator,
    },
    {
        field: "data_zakonczenia_badania",
        headerName: translations['data_zakonczenia_badania'].pl + ' (' + translations['data_zakonczenia_badania'].en + ')',
        renderHeader: _ => createHeaderMultiline('data_zakonczenia_badania'),
        type: "date",
        flex: 1,
        filterableByData: true,
        renderCell: (params) => {
            return renderValueOrPlaceholder(params)
        },
        valueGetter(params) {
            return getValueOrNull(params)
        },
        sortComparator: nullHandlingSortComparator,
    },
    {
        field: "miejsce_zdarzenia",
        headerName: translations['miejsce_zdarzenia'].pl + ' (' + translations['miejsce_zdarzenia'].en + ')',
        renderHeader: _ => createHeaderMultiline('miejsce_zdarzenia'),
        flex: 1,
        filterableByData: true,
        renderCell: (params) => {
            return renderCellExpandOrPlaceholder(params)
        },
        valueGetter(params) {
            return getValueOrNull(params)
        },
        sortComparator: nullHandlingSortComparator,
    },
    {
        field: "kategoria_statku_powietrznego",
        headerName: translations['kategoria_statku_powietrznego'].pl + ' (' + translations['kategoria_statku_powietrznego'].en + ')',
        renderHeader: _ => createHeaderMultiline('kategoria_statku_powietrznego'),
        flex: 1,
        filterableByData: true,
        renderCell: (params) => {
            return renderCellExpandOrPlaceholder(params)
        },
        valueGetter(params) {
            return getValueOrNull(params)
        },
        sortComparator: nullHandlingSortComparator,
    },
    {
        field: "typ_statku_powietrznego",
        headerName: translations['typ_statku_powietrznego'].pl + ' (' + translations['typ_statku_powietrznego'].en + ')',
        renderHeader: _ => createHeaderMultiline('typ_statku_powietrznego'),
        flex: 1,
        filterableByData: true,
        renderCell: (params) => {
            return renderCellExpandOrPlaceholder(params)
        },
        valueGetter(params) {
            return getValueOrNull(params)
        },
        sortComparator: nullHandlingSortComparator,
    },
    {
        field: "znaki_rozpoznawcze",
        headerName: translations['znaki_rozpoznawcze'].pl + ' (' + translations['znaki_rozpoznawcze'].en + ')',
        renderHeader: _ => createHeaderMultiline('znaki_rozpoznawcze'),
        flex: 1,
        filterableByData: true,
        renderCell: (params) => {
            return renderCellExpandOrPlaceholder(params)
        },
        valueGetter(params) {
            return getValueOrNull(params)
        },
        sortComparator: nullHandlingSortComparator,
    },
    {
        field: "raport_wstepny",
        headerName: translations['raport_wstepny'].pl + ' (' + translations['raport_wstepny'].en + ')',
        renderHeader: _ => createHeaderMultiline('raport_wstepny'),
        // type: 'boolean',
        flex: 1,
        filterableByData: true,
    },
    {
        field: "uchwala",
        headerName: translations['uchwala'].pl + ' (' + translations['uchwala'].en + ')',
        renderHeader: _ => createHeaderMultiline('uchwala'),
        // type: 'boolean',
        flex: 1,
        filterableByData: true,
    },
    {
        field: "raport_koncowy",
        headerName: translations['raport_koncowy'].pl + ' (' + translations['raport_koncowy'].en + ')',
        renderHeader: _ => createHeaderMultiline('raport_koncowy'),
        // type: 'boolean',
        flex: 1,
        filterableByData: true,
    },
    {
        field: "zalecenia_bezpieczenstwa",
        headerName: translations['zalecenia_bezpieczenstwa'].pl + ' (' + translations['zalecenia_bezpieczenstwa'].en + ')',
        renderHeader: _ => createHeaderMultiline('zalecenia_bezpieczenstwa'),
        // type: 'boolean',
        flex: 1,
        filterableByData: true,
    }
];

function getValueOrNull(params) {
    const value = params.row[params.field];
    return value !== 'BRAK/NA' ? value : null
}

function renderValueOrPlaceholder(params) {
    const value = params.row[params.field]
    if (value === 'BRAK/NA' || value === null) {
        return '-'
    }
    return value
}

function renderCellExpandOrPlaceholder(params) {
    if (params.row[params.field] === 'BRAK/NA' || params.row[params.field] === null) {
        return '-'
    }
    return renderCellExpand(params)
}

